// add navblock if full size mobile nav


// // General
jQuery(document).ready(function($){
let navbarToggler = document.querySelector(".navbar.full-screen .navbar-toggler");

if (navbarToggler) {
    let expanded = false;
    navbarToggler.addEventListener("click", e => {
        expanded = !expanded;
        if (expanded) {
            console.log("Expand");
            document.querySelector(".collapse.side .slide-menu").classList.add("show");
            if(window.innerWidth<992){
                document.children[0].classList.add("navBlock")
            }
        } else {
            console.log("Collapse");
            document.querySelector(".collapse.side .slide-menu").classList.remove("show");
            if(window.innerWidth<992){
                document.children[0].classList.remove("navBlock")
            }
        }
        
    })
}
})